export var SIGN_UP_INPUT_FIELD_ERROR;
(function(SIGN_UP_INPUT_FIELD_ERROR) {
    SIGN_UP_INPUT_FIELD_ERROR["MISSING"] = "missing";
    SIGN_UP_INPUT_FIELD_ERROR["LESS_THAN_MINIMUM"] = "less than minimum";
    SIGN_UP_INPUT_FIELD_ERROR["INVALID_VALUE"] = "invalid value";
    SIGN_UP_INPUT_FIELD_ERROR["LARGER_THAN_MAXIMUM"] = "larger than maximum";
})(SIGN_UP_INPUT_FIELD_ERROR || (SIGN_UP_INPUT_FIELD_ERROR = {}));
